export const AUTO_ADVANCE_QUESTION_TYPES: ReadonlySet<string> = new Set([
  "radio",
  "select",
]);
